const keys = {
  id: "ID",
  exportadora: "Exportadora",
  lote: "Lote",
  t_pulpa: "Temperatura pulpa",
  muestras_kg_neto: "Muestras kg neto",
  fecha_inspeccion: "Fecha inspeccion",
  hora_inspeccion: "Hora inspeccion",
  baxlo: "Baxlo",
  grados_brix: "Brix",
  t_ambiente: "Temperatura ambiente",
  responsable_inspeccion: "Responsable inspeccion",
  //////////////////////////

  // exudacion: "Exudacion",
  // machucones: "Machucones",
  // fruta_blanda: "Fruta blanda",
  // deshidratacion: "Deshidratacion",
  // nota_exudacion: "Nota exudacion",
  // nota_machucones: "Nota machucones",
  // bayas_reventadas: "Bayas reventadas",
  // nota_fruta_blanda: "Nota fruta blanda",
  // nota_deshidratacion: "Nota deshidratacion",
  // pedicelo_desgarrado: "Pedicelo desgarrado",
  // "bajo_calibre_<_12_mm": "Bajo calibre < 12 mm",
  // "inmaduro_rojo_>_20_%": "Inmaduro rojo > 20 %",
  // "inmaduro_verde_>_10_%": "Inmaduro verde > 10 %",
  "porcentaje_falta_bloom_>_30_%_superficie": "% Falta bloom > 30 % superficie",
  // "falta_bloom_>_30_%_superficie": "Falta bloom > 30 % superficie",
  porcentaje_pedicelo_desgarrado: "% Pedicelo desgarrado",
  "porcentaje_bajo_calibre_<_12_mm": "% Bajo calibre < 12 mm",
  "porcentaje_inmaduro_rojo_>_20_%": "% Inmaduro rojo > 20 %",
  // nota_russet_heridas_cicatrizadas: "Nota russet heridas cicatrizadas",
  "porcentaje_inmaduro_verde_>_10_%": "% Inmaduro verde > 10 %",
  porcentaje_resto_floral_pedicelo: "% Resto floral pedicelo",
  porcentaje_russet_heridas_cicatrizadas: "% Russet heridas cicatrizadas",
  suma_defectos_calidad_porcentaje: "Suma defectos calidad (%)",
  //////////////////////////
  porcentaje_exudacion: "% Exudacion",
  // nota_bayas_reventadas: "Nota bayas reventadas",
  // nota_defectos_calidad: "Nota defectos calidad",
  porcentaje_machucones: "% Machucones",
  // resto_floral_pedicelo: "Resto floral pedicelo",
  // nota_defectos_condicion: "Nota defectos condicion",
  porcentaje_fruta_blanda: "% Fruta blanda",
  // herida_abierta_partidura: "Herida abierta partidura",
  // nota_pedicelo_desgarrado: "Nota pedicelo desgarrado",
  // "nota_bajo_calibre_<_12_mm": "Nota bajo calibre < 12 mm",
  // "nota_inmaduro_rojo_>_20_%": "Nota inmaduro rojo > 20 %",
  porcentaje_deshidratacion: "% Deshidratacion",
  // "nota_inmaduro_verde_>_10_%": "Nota inmaduro verde > 10 %",
  // nota_resto_floral_pedicelo: "Nota resto floral pedicelo",
  porcentaje_bayas_reventadas: "% Bayas reventadas",
  // russet_heridas_cicatrizadas: "Russet heridas cicatrizadas",
  // nota_herida_abierta_partidura: "Nota herida abierta partidura",
  // "nota_falta_bloom_>_30_%_superficie": "Nota falta bloom > 30 % superficie",
  porcentaje_herida_abierta_partidura: "% Herida abierta partidura",
  suma_defectos_condicion: "Suma defectos condicion (%)",
  //////////////////////////
  suma_total_defectos: "Suma total defectos (%)",
  nota_final: "Nota final"
};

export default keys;
